var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCards = function SvgCards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M31.665 17.133V29.05c-.05 4.75-1.35 5.95-6.3 5.95H9.632c-5.033 0-6.3-1.25-6.3-6.217v-11.65c0-4.5 1.05-5.95 5-6.183.4-.017.833-.033 1.3-.033h15.733c5.034 0 6.3 1.25 6.3 6.216Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.665 11.217v11.65c0 4.5-1.05 5.95-5 6.183V17.133c0-4.966-1.266-6.216-6.3-6.216H9.632c-.467 0-.9.016-1.3.033.05-4.75 1.35-5.95 6.3-5.95h15.733c5.034 0 6.3 1.25 6.3 6.217ZM11.601 30.933H8.734a1.26 1.26 0 0 1-1.25-1.25c0-.683.567-1.25 1.25-1.25h2.867c.683 0 1.25.567 1.25 1.25 0 .684-.55 1.25-1.25 1.25ZM20.917 30.933h-5.733a1.26 1.26 0 0 1-1.25-1.25c0-.683.566-1.25 1.25-1.25h5.733c.683 0 1.25.567 1.25 1.25 0 .684-.55 1.25-1.25 1.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.665 19.767H3.332v2.5h28.333v-2.5Z",
    fill: "currentColor"
  })));
};
export default SvgCards;